import {useLocation} from "react-router-dom";
import React, {useEffect, useMemo, useState} from "react";
import {EditLocalStoragePagesData} from "../../../utils/EditLocalStoragePagesData";
import Box from "@mui/material/Box";
import {
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography
} from "@mui/material";
import ButtonCreate from "../../../components/UI/button/ButtonCreate";
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from "material-react-table";
import MenuItem from "@mui/material/MenuItem";
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import TextFieldValidation from "../../../components/UI/table/customer-detales/TextFieldValidation";
import ButtonExit from "../../../components/UI/button/ButtonExit";
import ButtonAdd from "../../../components/UI/button/ButtonAdd";
import AdminCurrencyNationalBankService from "../../../API/orders/warehouse/currency/AdminCurrencyNationalBankService";
import UserRolesService from "../../../API/admin/UserRolesService";
import FormControlLabel from "@mui/material/FormControlLabel";
import {replaceEmptyStringsOnNull} from "../../../utils/ReplaceEmptyStringsOnNull";

const allRoles = ["ADMIN", "ORGANIZATION", 'CUSTOMER', "NONE"]
const initValue = {
    name: "",
    description: "",
    userRoleType: allRoles[0],
    defaultUserType: allRoles[0],
    userRoleTypeAddCustomer: "DISABLED",
    userRoleTypeAddOrganization: "DISABLED"
}

const UserRolesAdmin = ({itemId, handleModalAlert}) => {
    const pathname = useLocation().pathname
    const [data, setData] = useState([]);
    const [modal, setModal] = useState(false);
    const [currentEditRowData, setCurrentEditRowData] = useState(initValue);
    const [loading, setLoading] = useState(false)
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })

    useEffect(() => {
        getStartPageSize()
        UserRolesService.getAll().then(function (response) {
            setData(response.data);
            setTableOptions((prev) => ({...prev, totalElements: response?.data.length}))
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, []);


    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(`${pathname}+${itemId}`, "pageSize", nextState.pageSize)
        }
    }

    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[`${pathname}+${itemId}`]?.pageSize
        pageSize && setTableOptions((prev) => ({...prev, pageSize: pageSize}))
    }

    const handleClose = () => {
        setModal(false)
        setCurrentEditRowData(initValue)
    }
    const handleDelete = (row) => {
        UserRolesService.delete(row.id)
            .then(function () {
                setData(prev => prev.filter(el => el.id !== row.id))
                tableOptionsHandle((prev) => ({...prev, totalElements: data.length - 1}))
                handleModalAlert("Данные удалены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error)
            })
    };
    const handleUpdate = (value) => {
        setLoading(true)
        UserRolesService.update(replaceEmptyStringsOnNull(value), value.id).then(function (response) {
            setData(prev => prev.map(el => el.id === value.id ? response.data : el));
            handleClose()
            handleModalAlert("Данные изменены", 'success')
        })
            .catch(function (error) {
                handleModalAlert(error);
            })
            .finally(() => setLoading(false))
    }

    const handleSubmit = (value) => {
        setLoading(true)
        UserRolesService.create(replaceEmptyStringsOnNull(value)).then(function (response) {
            setData([...data, response.data]);
            setTableOptions((prev) => ({...prev, totalElements: data.length + 1}))
            handleClose()
            handleModalAlert("Данные добавлены", 'success')
        })
            .catch(function (error) {
                handleModalAlert(error);
            })
            .finally(() => setLoading(false))
    }

    const handleAdd = () => {
        setModal(true)
    }
    const handleEdit = (row) => {
        setCurrentEditRowData(row);
        setModal(true)
    };

    const columns = useMemo(() => {
        const baseColumns = [
            {
                id: 'name',
                header: 'Наименование',
                accessorKey: 'name',
                size: 8,
                maxSize: 8,
            },
            {
                id: 'description',
                header: 'Описание',
                accessorKey: 'description',
                size: 510,
                grow: true,
            },
            {
                id: 'userRoleType',
                header: 'Тип роли',
                accessorKey: 'userRoleType',
                size: 8,
                maxSize: 8,
            }, {
                id: 'defaultUserType',
                header: 'Роль по умолчанию',
                accessorKey: 'defaultUserType',
                size: 8,
                maxSize: 8,
            },
            {
                header: 'Добавление заказчика',
                accessorKey: 'userRoleTypeAddCustomer',
                enableColumnActions: false,
                enableEditing: false,
                size: 8,
                minSize: 200,
                Cell: ({cell, row}) => <Checkbox
                    cell={cell}
                    checked={row.original.userRoleTypeAddCustomer === "ENABLED"}
                    sx={{padding: "7px", '& .MuiSvgIcon-root': {fontSize: 22}}}
                >
                </Checkbox>,
            },
            {
                header: 'Добавление организации',
                accessorKey: 'userRoleTypeAddOrganization',
                enableColumnActions: false,
                enableEditing: false,
                size: 8,
                minSize: 210,
                Cell: ({cell, row}) => <Checkbox
                    cell={cell}
                    checked={row.original.userRoleTypeAddOrganization === "ENABLED"}
                    sx={{padding: "7px", '& .MuiSvgIcon-root': {fontSize: 22}}}
                >
                </Checkbox>,
            }
        ]

        return baseColumns;

    }, [data]);

    const menuItem = [
        {type: "edit", text: "Редактировать", handler: handleEdit},
        {type: "delete", text: "Удалить", handler: handleDelete}
    ]

    return (<Box
        sx={{
            overflow: 'auto',
            maxWidth: 'calc(100vw - 410px)',
        }}>
        <Box sx={{display: 'flex', justifyContent: "space-between", paddingBottom: "30px"}}>
            <Typography sx={{fontSize: "24px", fontWeight: 700, lineHeight: 1}}>Роли</Typography>
            <ButtonCreate
                text={"Добавить роль"}
                width={170}
                onClick={handleAdd}
            />
        </Box>
        <MaterialReactTable
            renderTopToolbar={({table}) => {
                return <Box sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "7px",
                    backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                }}>
                    <MRT_ToolbarAlertBanner table={table}/>
                    <Box sx={{display: "flex"}}>
                        <MRT_ToggleFiltersButton table={table}/>
                        <MRT_GlobalFilterTextField table={table}/>
                    </Box>
                </Box>
            }}
            muiTableContainerProps={{
                sx: {
                    width: '2500px',
                    maxHeight: `calc(100vh - 420px)`
                }
            }}
            muiTableBodyCellProps={{
                sx: {
                    p: '0px 0px 0px 10px',
                    m: '0px 0px 0px 0px',
                    border: "none",
                    "& td:after": {
                        "&:hover": {
                            backgroundColor: "red"
                        }
                    },
                    "&:not(:last-of-type)": {
                        borderRight: '1px solid #EAEBEA',

                    },
                    "&:first-of-type": {
                        padding: 0,
                        width: "50px",
                        height: "36px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        color: (theme) => theme.palette.text.light,
                        "& .MuiButtonBase-root": {
                            borderRadius: "4px",
                            width: "24px",
                            height: "24px",
                            opacity: 1,
                            margin: 0,
                            padding: 0,
                            "&:hover": {
                                backgroundColor: (theme) => theme.palette.primary.stroke,
                            }
                        }
                    },
                    "& li": {
                        listStyleType: "none",
                        "& a": {
                            color: "#006CCC",
                            textDecoration: "none",
                            "&:hover": {
                                textDecoration: "underline"
                            }
                        }
                    }
                },
            }}
            muiTableHeadCellProps={{
                sx: {
                    border: '1px solid #EAEBEA',
                    backgroundColor: "#F5F6FA",
                    padding: "10px",
                    paddingBottom: " 0.2rem",
                    paddingTop: "0.2rem"
                },
            }}
            muiTableBodyRowProps={({row}) => {
                return ({
                    sx: () => ({
                        height: '36px',
                        backgroundColor: "white",
                        "&:hover& td:after": {
                            display: "none",
                        },
                        "&:hover": {
                            "& td:after": {
                                display: "none",
                            },
                        },
                        '&:nth-of-type(even)': {
                            backgroundColor: (theme) => theme.palette.primary.lightGrey,
                        },
                    })
                })
            }}

            displayColumnDefOptions={{
                'mrt-row-actions': {
                    header: "",
                    size: 3,
                    minSize: 3,
                    grow: false,
                },
            }}
            muiSearchTextFieldProps={{
                placeholder: `Поиск`,
                sx: {
                    paddingTop: "5px",
                    paddingBottom: "0px",
                    "& .MuiCollapse-root": {
                        borderRadius: '12px',
                        height: 40, width: 290,
                        "& .MuiSvgIcon-root": {
                            color: "#737478"
                        },
                        '& .MuiOutlinedInput-input': {
                            padding: 0
                        }
                    }
                },
                variant: 'outlined',
            }}
            columns={columns}
            data={data}
            rowHeight={13}
            columnSpacing={1}
            getRowId={(originalRow) => originalRow.id}
            selectionPadding={1}
            onPaginationChange={(updater) => {
                tableOptionsHandle(updater(tableOptions));
            }}
            state={{showGlobalFilter: true, pagination: tableOptions,}}
            rowCount={tableOptions.totalElements}
            selectionCss={{
                backgroundColor: 'lightblue',
                borderWidth: '2px',
                borderStyle: 'solid',
                borderColor: 'blue',
                borderRadius: '4px',
            }}
            renderRowActionMenuItems={({closeMenu, row}) => menuItem.map(el => {
                return <MenuItem
                    key={el.type}
                    onClick={() => {
                        el.handler(row.original)
                        closeMenu();
                    }}
                    sx={{
                        margin: "0 8px",
                        borderRadius: "4px",
                        "&:hover": {backgroundColor: (theme) => theme.palette.primary.light}
                    }}
                >
                    {el.text}
                </MenuItem>
            })
            }
            localization={MRT_Localization_RU}
            enableRowActions={true}
            enableToolbarInternalActions={false}
        />
        <UserRolesModal
            title={currentEditRowData.id ? "Изменить" : "Добавить"}
            open={modal} onClose={handleClose}
            handleSubmit={currentEditRowData.id ? handleUpdate : handleSubmit}
            initValue={currentEditRowData}
            handleModalAlert={handleModalAlert}
            allRoles={allRoles}
            loading={loading}
        />
    </Box>);
};

const UserRolesModal = ({open, onClose, handleSubmit, initValue, title, allRoles, loading}) => {
    const [formState, setFormState] = useState(initValue)

    useEffect(() => {
        setFormState(initValue)
    }, [initValue])

    return (
        <Dialog open={open} PaperProps={{
            style: {
                minWidth: "400px",
                borderRadius: 8,
            }
        }}>
            <DialogTitle textAlign="center">{title}</DialogTitle>
            <DialogContent sx={{display: 'flex', flexDirection: "column"}}>
                <TextFieldValidation
                    name={"name"}
                    value={formState?.name}
                    label="Наименование"
                    setCurrValues={setFormState}
                />
                <TextFieldValidation
                    name={"description"}
                    value={formState?.description}
                    label="Описание"
                    setCurrValues={setFormState}
                />

                <TextFieldValidation
                    select
                    name="userRoleType"
                    label="Тип роли"
                    value={formState?.userRoleType}
                    setCurrValues={setFormState}
                >
                    {allRoles.map((option) => (
                        <MenuItem key={option} value={option}>
                            {option}
                        </MenuItem>
                    ))}
                </TextFieldValidation>
                <TextFieldValidation
                    select
                    name="defaultUserType"
                    label="Роль по умолчанию"
                    value={formState?.defaultUserType}
                    setCurrValues={setFormState}
                >
                    {allRoles.map((option) => (
                        <MenuItem key={option} value={option}>
                            {option}
                        </MenuItem>
                    ))}
                </TextFieldValidation>
                <FormControlLabel control={<Checkbox
                    checked={formState?.userRoleTypeAddCustomer === "ENABLED"}
                    onChange={() => setFormState(value => ({
                        ...value,
                        userRoleTypeAddCustomer: formState?.userRoleTypeAddCustomer === "ENABLED" ? "DISABLED" : "ENABLED"
                    }))}
                />} label={"Добавление заказчика"}/>
                <FormControlLabel control={<Checkbox
                    checked={formState?.userRoleTypeAddOrganization === "ENABLED"}
                    onChange={() => setFormState(value => ({
                        ...value,
                        userRoleTypeAddOrganization: formState?.userRoleTypeAddOrganization === "ENABLED" ? "DISABLED" : "ENABLED"
                    }))}
                />} label={"Добавление организации"}/>

            </DialogContent>
            <DialogActions sx={{p: '1.25rem'}}>
                <ButtonExit text={"Отменить"} onClick={onClose}/>
                <ButtonAdd loading={loading} text={"Выбрать"} onClick={() => handleSubmit(formState)}/>
            </DialogActions>
        </Dialog>
    );
}

export default UserRolesAdmin;